import usePWA, { Status } from './usePWA'
import { isIOS, isInPWA, ch } from '@/env'
import { downloadFile,  getImageUrl } from '@/utils'
import { getInstallConfig } from '@/api/config'
import { until } from '@vueuse/core'
import { useUserInfo } from '@/store'
import showPopup from '@a/components/showPopup'
import AddToHomeScreen from '@a/components/Installation/AddToHomeScreen.vue'

interface iConfig {
  install: 'Enabled' | 'Disabled'
  content: 'Normal' | 'giveEggs'
  presentAmountView: number
  time: 'OnHome' | 'AfterUserDeposit'
  interval: number
  apple: 'Desktop' | 'Appstore'
  appleLink: string
  android: 'Pwa' | 'Apk' | 'pwaApk'
  apkLink: string
}

const { status, installPWA, launchPWA } = usePWA()

const config = ref<iConfig | null>(null)

const updateInstallConfig = async () => {
  const channelNo = useUserInfo().userInfo?.channelNo
  const { code, data } = await getInstallConfig({ch: channelNo || ch || 0})
  if (code === 1 && data) {
    config.value = data
  }
};

enum androidInstallType {
  Pwa = 'Pwa',
  Apk = 'Apk',
  PwaApk = 'pwaApk'
}

const downloadApk = (apkLink: string, fileName: string) => {
  const link = apkLink && getImageUrl(apkLink)
  if (link) {
    downloadFile(link, fileName)
  } else {
    // showToast('Pacote de download não configurado')
  }
}

let i = 0
const install = async (fn?: () => Promise<void>) => {
  if (localStorage['pwaInstalled'] == '2') {
    launchPWA()

    if (status.value == Status.INSTALL_SUCCESS) return
  }

  if (!config.value) {
    console.warn('installation config is null')
    return
  }

  const { apple, appleLink, android, apkLink } = config.value
  if (isIOS) {
    if (apple == 'Desktop') {
      showPopup(AddToHomeScreen, {
        position: 'bottom',
        closeOnClickOverlay: true
      })
    } else {
      window.open(appleLink);
    }
  } else {
    const fileName = apkLink ? apkLink.split('/').pop() : '9jogos.apk';
    if (android == androidInstallType.Apk) {
      downloadApk(apkLink, fileName!)
    } else {
      // if (!isChrome && isAndroid && isFacebookApp) {
      //   launchChrome()
      //   return
      // }

      let installPWA_FN = fn || installPWA
      await installPWA_FN()

      if (android == androidInstallType.PwaApk) {
        let a = ++i
        await until(status).toMatch(v => (v == Status.CHECK_FAILED || v == Status.USER_DISMISSED) && a == i)
        downloadApk(apkLink, fileName!)
      }
    }
  }
}

const init = async () => {
  if (isInPWA) return

  await updateInstallConfig()
}

export default function useAPP() {
  return { config, install, init }
}
